module.exports = __webpack_public_path__ + "static/media/phone.765b798f.svg";